module.exports = {"locale":"en","date":{"formats":{"short":"MMM DD, YYYY"}},"toast":{"success":{"contact_us_submit":"Your question is super important to us, we'll be in contact with you soon. Thank You!"}}}


//////////////////
// WEBPACK FOOTER
// ./src/config/locales/en.json
// module id = 482
// module chunks = 0